export default "__VITE_ASSET__Xa5vCs0Y__"